import React from 'react';
import { Crown, Lock } from 'lucide-react';
import { Badge } from './ui/badge';

const PremiumBadge = ({ type = 'badge', size = 'sm' }) => {
  if (type === 'badge') {
    return (
      <Badge className="bg-gradient-to-r from-yellow-500 to-orange-500 text-white text-xs font-semibold">
        <Crown className="h-3 w-3 mr-1" />
        Premium
      </Badge>
    );
  }

  if (type === 'overlay') {
    return (
      <div className="absolute inset-0 bg-black/60 flex items-center justify-center rounded-lg">
        <div className="text-center text-white">
          <Lock className="h-8 w-8 mx-auto mb-2 opacity-80" />
          <div className="font-semibold text-sm">Premium Content</div>
          <div className="text-xs opacity-90">Wanderloop+ required</div>
        </div>
      </div>
    );
  }

  return null;
};

export default PremiumBadge;